module.exports = __webpack_public_path__ + "static/media/a-3-d.7ab4867e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-3-d.jpg
// module id = 1099
// module chunks = 33